<template>
    <fieldset class="fieldset">
      <legend class="legend" :class="requiredClass">
        <slot name="legend"></slot>
      </legend>
      <div class="twin">
        <div class="twin-item">
          <div class="select-wrap">
            <label class="label" :for="inputNames[0]">
              {{ labels[0] }}
            </label>
            <select :id="inputNames[0]" class="select" :name="inputNames[0]" @change="$emit('change', $event)">
              <option value="">指定しない</option>
              <option v-for="item in items" :key="item[valueProp]" :value="item[valueProp]">{{ item[labelProp] }}</option>
            </select>
          </div>
        </div>
        <p class="tilde">～</p>
        <div class="twin-item">
          <div class="select-wrap">
            <label class="label" :for="inputNames[1]">
              {{ labels[1] }}
            </label>
            <select :id="inputNames[1]" class="select" :name="inputNames[1]" @change="$emit('change', $event)">
              <option value="">指定しない</option>
              <option v-for="item in items" :key="item[valueProp]" :value="item[valueProp]">{{ item[labelProp] }}</option>
            </select>
          </div>
        </div>
      </div>
    </fieldset>
</template>

<script>
export default {

  props: {
    inputNames: {
      type: Array,
      required: true
    },

    items: {
      type: Array,
      default: () => []
    },

    labels: {
      type: Array,
      required: true
    },

    // 表示名のプロパティ
    labelProp: {
      type: String,
      default: 'label'
    },

    // 値のプロパティ
    valueProp: {
      type: String,
      default: 'value'
    },

    // 必須項目か
    required: {
      type: Boolean,
      required: true
    }
  },
  emits: ['change'],

  computed: {
    requiredClass: function () {
      const className = this.required ? 'required' : 'elective'

      const result = {}
      result[className] = true

      return result
    }
  }
}
</script>
